/*
* Copyright (C) Regione Lombardia
*/
import { Component, Input, OnInit } from '@angular/core';
import { CoreI18nConfigs } from '@core/configs/i18n.config';
import { DatalistAnagrafica, Rilevamento } from '@models';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OperaService } from '@shared/services/opera.service';
import { UtilsService } from '@shared/services/utils.service';
import { ToolkitGestioneOperaModalSopralluogoComponent } from '../modal-sopralluogo/modal-sopralluogo.component';

@Component({
    selector: 'app-toolkit-opera-tab-sopralluoghi',
    templateUrl: './tab-sopralluoghi.component.html',
})
export class ToolkitGestioneOperaTabSopralluoghiComponent implements OnInit {

    @Input() canEdit: boolean;
    @Input() items: Rilevamento[] = [];
    @Input() datalist: DatalistAnagrafica;

    constructor(
        private modalService: NgbModal,
        private operaService: OperaService,
        private utilsService: UtilsService
    ) { }


    ngOnInit(): void {
        this.operaService.rilevamentoByIdOpera(this.operaService.operaSession.idOpera).subscribe((list: Rilevamento[]) => {
            this.items = list;
        });
    }
    
    public viewItem(rilevamento: Rilevamento) {
        const modal = this.modalService.open(ToolkitGestioneOperaModalSopralluogoComponent, {size: 'xl'});
        modal.componentInstance.azione = 'Visualizza';
        modal.componentInstance.datalist = this.datalist;
        modal.componentInstance.params = rilevamento;
    }

    public addItem() {
        const modal = this.modalService.open(ToolkitGestioneOperaModalSopralluogoComponent, {size: 'xl'});
        modal.componentInstance.azione = 'Aggiungi';
        modal.componentInstance.datalist = this.datalist;
        modal.componentInstance.canEdit = true;
        modal.result.then(result => {
            if (result) {
                this.operaService.insertRilevamento(result.getRawValue()).subscribe(response => {
                    this.utilsService.showSuccess(CoreI18nConfigs.messages.genericSuccess);
                    this.operaService.rilevamentoByIdOpera(this.operaService.operaSession.idOpera).subscribe((list: Rilevamento[]) => {
                        this.items = list;
                    });
                });
            }
        }
       ).catch(e => {});
    }

    public editItem(rilevamento: Rilevamento) {
        const modal = this.modalService.open(ToolkitGestioneOperaModalSopralluogoComponent, {size: 'xl'});
        modal.componentInstance.azione = 'Modifica';
        modal.componentInstance.datalist = this.datalist;
        modal.componentInstance.params = rilevamento;
        modal.componentInstance.canEdit = true;
        modal.result.then(result => {
            if (result) {
                this.operaService.updateRilevamento(result.getRawValue()).subscribe(response => {
                    this.utilsService.showSuccess(CoreI18nConfigs.messages.genericSuccess);
                    this.operaService.rilevamentoByIdOpera(this.operaService.operaSession.idOpera).subscribe((list: Rilevamento[]) => {
                        this.items = list;
                    });
                });
            }
        }).catch(e => {});
    }

    public deleteItem(idRilevamento: number) {
        this.operaService.deleteRilevamento(idRilevamento).subscribe(response => {
            if (this.utilsService.genericResponse204NoContent(response)) {
                this.operaService.rilevamentoByIdOpera(this.operaService.operaSession.idOpera).subscribe((list: Rilevamento[]) => {
                    this.items = list;
                });
            }
        });
    }

}
